<template>
  <FAQAskModal :show="modalShowed" @close="modalShowed = false" />

  <FloatingActionButton
    icon="Help"
    color="blue"
    :title="$t('ui.faq.ask_question.ask_button')"
    @click="modalShowed = true"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import FAQAskModal from './FAQAskModal.vue'
import FloatingActionButton from '@/components/controls/FloatingActionButton'

const modalShowed = ref(false)
</script>
